"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var CourseCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(CourseCard, _Card$makeDefaultCard);

  function CourseCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CourseCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CourseCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "status", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "percent", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "person", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CourseCard, [{
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      if (this.status == 'in-progress') {
        return _react.default.createElement("div", {
          className: "pie",
          "data-pie": this.percent
        });
      }

      if (this.status == 'complete') {
        return _react.default.createElement("div", {
          className: "pie",
          "data-pie": "100"
        });
      }

      return null;
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) {
        return babelHelpers.get(babelHelpers.getPrototypeOf(CourseCard.prototype), "renderBottomContent", this).call(this);
      }

      if (this.person) {
        return [!!this.person.image && _react.default.createElement("div", {
          key: "photo",
          className: "image",
          style: {
            backgroundImage: "url(".concat(this.person.image, ")")
          }
        }), _react.default.createElement("p", {
          key: "name"
        }, this.person.name, this.person.icons.length > 0 && _react.default.createElement("span", {
          className: "account-icon-list"
        }, this.person.icons.map(function (icon) {
          return _react.default.createElement("img", {
            className: "account-icon",
            key: icon.id,
            src: icon.icon,
            title: icon.title
          });
        }))), !!this.person.title && _react.default.createElement("p", {
          key: "title",
          className: "person-title"
        }, this.person.title)];
      }

      return null;
    }
  }]);
  return CourseCard;
}(_base.default.makeDefaultCardType('course', 'Course')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "status", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "percent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "person", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = CourseCard;